import {localStatusReducer} from './local-status/localStatusReducer';
import {combineReducers} from 'redux';
import {apiReducer} from '../pages/global/api-check/APIReducer';
import {systemUserManagementReducer} from '../pages/admin-panel/system-right-management/systemUserManagementReducer';
import { projectUserManagementReducer } from '../pages/project-user-management/projectUserManagementReducer';

export const uiReducer = combineReducers({
    systemUserManagement: systemUserManagementReducer,
    projectUserManagement: projectUserManagementReducer,
    status: localStatusReducer,
    api: apiReducer,
});
